module.exports = __webpack_public_path__ + "static/media/happy.3fc76460.png";